import moment from 'moment';

import { isValidPhone } from '@/helpers/phone';
import { isValidEmail } from '@/helpers/validation';

export enum CandidateFieldType {
	String = 'string',
	Date = 'date',
	Phone = 'phone',
	Email = 'email',
}

const SPECIAL_CHARACTERS_PATTERN = /[|"`]/g;
const MIN_AGE_YEARS = 16;

export const isValidCandidateField = (
	value: string,
	type: CandidateFieldType
): boolean => {
	if (value === '') return true;

	switch (type) {
		case CandidateFieldType.Date:
			return moment(value).isBefore(moment().subtract(MIN_AGE_YEARS, 'years'));
		case CandidateFieldType.Phone:
			return isValidPhone(value);
		case CandidateFieldType.Email:
			return isValidEmail(value);
		case CandidateFieldType.String:
			return !SPECIAL_CHARACTERS_PATTERN.test(value);
	}
};
